import React, { useState } from "react"
import PropTypes from "prop-types"
import _ from "lodash"

import { dinero, etiquetaRecepcion, piezas } from "../helpers"
import CancelOrderModal from "./CancelOrderModal"

const DayOrdersStrip = ({ pedidos, abierto, isSaving, onToggle, onEliminar }) => {
  const [porCancelar, setPorCancelar] = useState(null)

  const onConfirmarCancelacion = () => {
    onEliminar(porCancelar.id)
    setPorCancelar(null)
  }

  return (
    <div className="pv2-dia">
      <button type="button" className="pv2-dia-toggle" onClick={onToggle}>
        <span className={`pv2-caret${abierto ? "" : " is-closed"}`}>▾</span>
        <span className="pv2-dia-title">Pedidos del día</span>
        <span className="pv2-dia-count">{pedidos.length}</span>
      </button>

      {abierto && (
        <div className="pv2-chips">
          {pedidos.map(pedido => (
            <div key={pedido.id} className="pv2-chip">
              <span className={`pv2-chip-dot${pedido.local ? " is-granja" : ""}`} />
              <span className="pv2-chip-prov">{pedido.proveedor}</span>
              <span className="pv2-chip-prod">{pedido.producto}</span>
              <span className="pv2-mono pv2-chip-pzas">
                {piezas(pedido.piezas)} pz
              </span>
              <span className="pv2-mono pv2-chip-precio">
                ${dinero(pedido.precio)}
              </span>
              <span className={`pv2-modo${pedido.local ? " is-granja" : ""}`}>
                {pedido.local ? "Granja" : "Reparto"}
              </span>
              <span className="pv2-mono pv2-chip-cuando">
                {etiquetaRecepcion(pedido.recepcion)}
              </span>
              <button
                type="button"
                className="pv2-chip-del"
                title="Cancelar pedido"
                disabled={isSaving}
                onClick={() => setPorCancelar(pedido)}
              >
                ✕
              </button>
            </div>
          ))}
          {pedidos.length === 0 && (
            <span className="pv2-dia-empty">
              Aún no hay pedidos capturados para este día.
            </span>
          )}
        </div>
      )}

      <div className="pv2-dia-totales">
        <div>
          <div className="pv2-mini-label">Piezas</div>
          <div className="pv2-mono pv2-dia-num">
            {piezas(_.sumBy(pedidos, "piezas"))}
          </div>
        </div>
        <div>
          <div className="pv2-mini-label">Importe</div>
          <div className="pv2-mono pv2-dia-num is-strong">
            ${dinero(_.sumBy(pedidos, pedido => pedido.piezas * pedido.precio))}
          </div>
        </div>
      </div>

      <CancelOrderModal
        pedido={porCancelar}
        isSaving={isSaving}
        onCancel={() => setPorCancelar(null)}
        onConfirm={onConfirmarCancelacion}
      />
    </div>
  )
}

DayOrdersStrip.propTypes = {
  pedidos: PropTypes.array.isRequired,
  abierto: PropTypes.bool.isRequired,
  isSaving: PropTypes.bool,
  onToggle: PropTypes.func.isRequired,
  onEliminar: PropTypes.func.isRequired,
}

export default DayOrdersStrip
